'use client';

import { type ComponentProps, type JSX } from 'react';

import { LoadingCard } from './LoadingCard';
import { PlaybackCard } from './PlaybackCard';

export type AiToolkitVideoPlayerProps = {
    state: 'loading' | 'playback';
    thumbnailUrl?: string;
    thumbnailAlt?: string;
} & ComponentProps<'video'>;

export function AiToolkitVideoPlayer({
    state,
    thumbnailUrl,
    thumbnailAlt,
    ...videoProps
}: AiToolkitVideoPlayerProps): JSX.Element {
    if (state === 'loading') {
        return <LoadingCard thumbnailUrl={thumbnailUrl} thumbnailAlt={thumbnailAlt} />;
    }
    return <PlaybackCard {...videoProps} />;
}
